"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountPricingTypeEnum = exports.DiscountRestrictionTypeEnum = exports.DiscountAmountRuleType = exports.DiscountTargetType = exports.DiscountOriginType = void 0;
var DiscountOriginType;
(function (DiscountOriginType) {
    DiscountOriginType["CUSTOM"] = "custom";
    DiscountOriginType["AUTOMATIC"] = "automatic";
    DiscountOriginType["DISCOUNT_CODE"] = "discountCode";
})(DiscountOriginType = exports.DiscountOriginType || (exports.DiscountOriginType = {}));
var DiscountTargetType;
(function (DiscountTargetType) {
    DiscountTargetType["ORDER"] = "order";
    DiscountTargetType["ORDER_PRODUCT"] = "orderProduct";
    DiscountTargetType["SHIPPING"] = "shipping";
})(DiscountTargetType = exports.DiscountTargetType || (exports.DiscountTargetType = {}));
var DiscountAmountRuleType;
(function (DiscountAmountRuleType) {
    DiscountAmountRuleType["PERCENTAGE"] = "percentage";
    DiscountAmountRuleType["FIXED_AMOUNT"] = "fixedAmount";
    DiscountAmountRuleType["FREE_PRODUCTS"] = "freeProducts";
})(DiscountAmountRuleType = exports.DiscountAmountRuleType || (exports.DiscountAmountRuleType = {}));
var DiscountRestrictionTypeEnum;
(function (DiscountRestrictionTypeEnum) {
    DiscountRestrictionTypeEnum["SUBTOTAL"] = "subtotalLimit";
    DiscountRestrictionTypeEnum["PRICING_TYPE"] = "pricingType";
    DiscountRestrictionTypeEnum["CUSTOMER"] = "customer";
    DiscountRestrictionTypeEnum["DISCOUNT_CODE"] = "discountCode";
    DiscountRestrictionTypeEnum["EXISTING_VARIANTS"] = "existingVariants";
    DiscountRestrictionTypeEnum["EXISTING_PRODUCTS"] = "existingProducts";
    DiscountRestrictionTypeEnum["EXISTING_CATEGORIES"] = "existingCategories";
    DiscountRestrictionTypeEnum["TARGET_VARIANTS"] = "targetVariants";
    DiscountRestrictionTypeEnum["TARGET_PRODUCTS"] = "targetVariant";
    DiscountRestrictionTypeEnum["TARGET_CATEGORIES"] = "targetCategories";
    DiscountRestrictionTypeEnum["ORDER_ITEMS_QUANTITY"] = "totalItemsQuantity";
    DiscountRestrictionTypeEnum["CURRENCY"] = "currency";
    DiscountRestrictionTypeEnum["CUSTOMER_SEGMENT"] = "customerSegment";
    DiscountRestrictionTypeEnum["TIME_RESTRICTION"] = "timeRestriction";
    DiscountRestrictionTypeEnum["SHIPPING_COST"] = "shippingCost";
    DiscountRestrictionTypeEnum["SHIPPING_COUNTIES"] = "shippingCounties";
    DiscountRestrictionTypeEnum["COMBINATIONS"] = "combinations";
    DiscountRestrictionTypeEnum["USAGE_LIMIT"] = "usageLimit";
})(DiscountRestrictionTypeEnum = exports.DiscountRestrictionTypeEnum || (exports.DiscountRestrictionTypeEnum = {}));
var DiscountPricingTypeEnum;
(function (DiscountPricingTypeEnum) {
    DiscountPricingTypeEnum["RETAIL"] = "retail";
    DiscountPricingTypeEnum["WHOLESALE"] = "wholesale";
    DiscountPricingTypeEnum["ANY"] = "any";
})(DiscountPricingTypeEnum = exports.DiscountPricingTypeEnum || (exports.DiscountPricingTypeEnum = {}));
;
